import { render, staticRenderFns } from "./FormMetodePencairan.vue?vue&type=template&id=6b535634&"
import script from "./FormMetodePencairan.vue?vue&type=script&lang=js&"
export * from "./FormMetodePencairan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports